import editicon from "./edit_icon_24px.png";
import editIconDarkGray from "./edit_icon_darkGray_18px.png";
import editIconGray from "./edit_icon_gray_16px.png";

export type EditIconProps = {
  color?: "green" | "darkGray" | "gray";
};

const EDIT_IMAGES: Record<"green" | "darkGray" | "gray", string> = {
  green: editicon,
  darkGray: editIconDarkGray,
  gray: editIconGray,
};

export const EditIcon = ({ color }: EditIconProps) => (
  <img src={EDIT_IMAGES[color || "green"]} alt="Edit icon" />
);
